export enum FlowState {
  Complete = 'complete',
  Error = 'error',
  Idle = 'idle',
  Loaded = 'loaded',
  Loading = 'loading',
  LoadingHistory = 'loading-history',
  LoadingMore = 'loading-more',
  MissingRequiredInfo = 'missing-required-info',
  NoResults = 'no-results',
  NotFound = 'not-found',
  Pending = 'pending',
  Review = 'review',
  Saving = 'saving',
  SendingToBusinessCentral = 'sending-to-business-central'
}
